/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Card,
  Divider,
  Flex,
  Form,
  FormInstance,
  Input,
  Modal,
} from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';

const EditTransactionLimits = ({
  title,
  open,
  maximumLimit,
  onClose,
  form,
  currency,
  onHandleSubmit,
}: {
  currency: string;
  form: FormInstance<any> | undefined;
  title: string;
  open: boolean;
  maximumLimit: string;
  onClose: () => void;
  onHandleSubmit: () => void;
}) => {
  const { translate } = useLanguage();
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={translate(title)}
      footer={null}
    >
      <Flex gap="small" vertical>
        <span>
          {translate(
            'An overview of your account transaction limits',
          )}
        </span>
        <Card size="small">
          <Flex align="center" justify="space-between">
            <span>{translate('Maximum limit')}</span>
            <span className="font-weight-bold">{maximumLimit}</span>
          </Flex>
        </Card>
        <Form form={form} layout="vertical" onFinish={onHandleSubmit}>
          <Form.Item
            name="amount"
            label={translate('Default limit')}
            rules={[{ required: true }]}
          >
            <Input
              suffix={currency}
              placeholder="0.0"
              type="number"
            />
          </Form.Item>
          <Form.Item>
            <Flex
              align="center"
              justify="space-between"
              style={{ width: '100%' }}
            >
              <Button type="primary" onClick={onClose} ghost danger>
                {translate('Cancel')}
              </Button>
              <Button htmlType="submit" type="primary" ghost>
                {translate('Confirm')}
              </Button>
            </Flex>
          </Form.Item>
        </Form>
      </Flex>
    </Modal>
  );
};

export default EditTransactionLimits;
